module.exports = __webpack_public_path__ + "img/0-md.f537d655.jpg";